import GcIcon from '../GcIcon/index.vue';

export default {
  name: 'GcInput',
  data() {
    return {
      className: 'gc__input',
      validationError: '',
    };
  },
  components: {
    GcIcon,
  },
  computed: {
    fieldClassName() {
      return `${this.className}__field`;
    },
    labelClassName() {
      return `${this.className}__label`;
    },
    errorMessageClassName() {
      return `${this.className}__error-message`;
    },
    requiredClassName() {
      return this.required ? `${this.className}__required` : '';
    },
    disabledClassName() {
      return this.disabled ? `${this.className}__disabled` : '';
    },
    errorClassName() {
      return this.validationError ? `${this.className}__error` : '';
    },
    hideLabelClassName() {
      return this.hideLabel ? `${this.className}--hidden` : '';
    },
    inputContainerClassName() {
      return `${this.className}__container`;
    },
    buttonClassName() {
      return `${this.className}__button--${this.buttonType} ${this.className}__button`;
    },
    uniqueId() {
      return `${this.className}--${Math.round(Math.random() * 100000)}`;
    },
    buttonDisabled() {
      return this.buttonType === 'disabled';
    },
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    max: {
      type: [Date, Number],
      default: null,
    },
    min: {
      type: [Date, Number],
      default: null,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    buttonTitle: {
      type: String,
      default: 'Submit',
    },
    validationRules: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: [String, Number],
      default: null,
    },
    styleObject: {
      type: Object,
      default: null,
    },
    withButton: {
      type: Boolean,
      default: false,
    },
    buttonType: {
      type: String,
      default: 'primary',
      validator(value) {
        // The value must match one of these strings
        return ['primary', 'secondary', 'disabled'].indexOf(value) !== -1;
      },
    },
  },
  watch: {
    value() {
      this.$emit('input', this.value);
    },
  },
  methods: {
    validate() {
      if (this.validationRules) {
        this.validationRules.forEach((f) => {
          const result = f(this.value);
          this.validationError = result === true ? '' : result;
        });
      }
    },
  },
};
